/**
 * PWA Installation Handler
 * 
 * This utility manages the PWA installation process and provides hooks
 * for handling the install prompt event.
 */

// Store the deferred prompt for later use
let deferredPrompt: any = null;

/**
 * Check if the app can be installed
 * @returns {boolean} Whether the app can be installed
 */
export const isPWAInstallable = (): boolean => {
  return !!deferredPrompt;
};

/**
 * Initialize PWA installation listener
 * This should be called when the app starts
 */
export const initPWA = (): void => {
  // Listen for the beforeinstallprompt event
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later
    deferredPrompt = e;
    console.log('PWA install prompt ready');
  });

  // Listen for successful installation
  window.addEventListener('appinstalled', () => {
    // Clear the deferredPrompt
    deferredPrompt = null;
    console.log('PWA was installed');
  });
};

/**
 * Show the installation prompt
 * @returns {Promise<boolean>} Whether the user accepted the installation
 */
export const promptPWAInstall = async (): Promise<boolean> => {
  if (!deferredPrompt) {
    console.log('Cannot install PWA: prompt not available');
    return false;
  }

  // Show the install prompt
  deferredPrompt.prompt();

  // Wait for the user to respond to the prompt
  const { outcome } = await deferredPrompt.userChoice;
  
  // Clear the deferredPrompt
  deferredPrompt = null;

  return outcome === 'accepted';
};